export const getLatestConversationActivity = (conversation) => {
  const message = conversation?.ChatMessages?.[0];
  const proposals = conversation?.direct
    ? conversation?.directChat?.propositions || []
    : (conversation?.indirectChat?.offer?.Offer_Proposals || []).filter(
        (proposal) => Number(proposal.technicianId) === Number(conversation.technicianId),
      );
  const proposal = proposals.reduce(
    (latest, item) =>
      !latest || new Date(item.createdAt) > new Date(latest.createdAt)
        ? item
        : latest,
    null,
  );
  if (proposal && (!message || new Date(proposal.createdAt) > new Date(message.createdAt))) {
    return {
      createdAt: proposal.createdAt,
      preview: `Proposition : ${proposal.title || "nouvelle proposition"}`,
    };
  }
  if (message) {
    return {
      createdAt: message.createdAt,
      preview: message.deletedAt
        ? "Message supprimé"
        : message.text?.trim() || (message.FileUploads?.length ? "Pièce jointe" : "Message"),
    };
  }
  return {createdAt: conversation?.createdAt, preview: "Nouvelle conversation"};
};
